import { Flex, Select } from '@workos-inc/design-system';
import { useRouter } from 'next/router';
import { AUTHKIT_STACK_OPTIONS, StackOption } from 'src/utils/authkit-stack-options';
const getCurrentStack = (slug: string): StackOption | undefined => {
  // Match against the stack hrefs to find the current stack
  // slug format: /authkit/nextjs/... or /authkit/vanilla/nodejs/...
  return AUTHKIT_STACK_OPTIONS.find(option => slug.startsWith(option.href));
};
interface AuthKitStackSelectorProps {
  currentSlug: string;
}
export const AuthKitStackSelector = ({
  currentSlug
}: AuthKitStackSelectorProps) => {
  const router = useRouter();
  const currentStack = getCurrentStack(currentSlug);
  if (!currentStack) {
    return null;
  }
  const handleStackChange = (href: string) => {
    void router.push(href);
  };
  return <Select.Root value={currentStack.href} onValueChange={handleStackChange} data-sentry-element="Select.Root" data-sentry-component="AuthKitStackSelector" data-sentry-source-file="authkit-stack-selector.tsx">
      <Select.Trigger data-sentry-element="Select.Trigger" data-sentry-source-file="authkit-stack-selector.tsx" />
      <Select.Content align="end" position="popper" data-sentry-element="Select.Content" data-sentry-source-file="authkit-stack-selector.tsx">
        {AUTHKIT_STACK_OPTIONS.map(option => {
        const Icon = option.icon;
        return <Select.Item key={option.href} value={option.href}>
              <Flex align="center" gap="2">
                <Icon height="16" width="16" />
                {option.title}
              </Flex>
            </Select.Item>;
      })}
      </Select.Content>
    </Select.Root>;
};